import React, { Component } from "react";
import { Table, Button, Modal, Form, Input, Select } from "antd";
import { api, app } from "../../app";
import utils from "../../utils";
import PropTypes from "prop-types";

const Option = Select.Option;
const FormItem = Form.Item;

class ExpulsionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_loading: true,
      playerList: [],
      rights: app.getData("rights"),
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.dataSource(this.props.teamno);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentWillReceiveProps(props) {
    this.dataSource(props.teamno);
  }

  /**
   * 设置值
   * @param data
   * @param cb
   */
  setData = (data, cb) => {
    if (this._isMounted) {
      this.setState(data, () => {
        if (cb) cb();
      });
    }
  };

  /**
   * 恢复
   * @param info
   */
  handleRecovery = (restoreInfo) => {
    this.setData({ restoreInfo, restore_visible: true });
  };

  /**
   * 关闭弹框
   */
  handleCloseModal = () => {
    this.setData({
      restoreInfo: {},
      restore_visible: false,
      restore_loading: false,
    });
  };
  /**
   * 提交恢复信息
   * @param e
   * @returns {Promise<void>}
   */
  handleSubmitRecovery = (e) => {
    let { restoreInfo } = this.state;
    if (!this.state.restore_loading) {
      e.preventDefault();
      this.props.form.validateFields(async (err, values) => {
        if (!err) {
          await this.setData({ restore_loading: true });
          values.volunteer_id = restoreInfo.volunteer_id,
          values.teamno=this.props.teamno,
          values.indexno = app.getData("indexno");
          values.account = app.getData("account");
          const { flag, msg } = await app.post(api.LeaveTeamRestore, values)
          if (flag === 1) {
              app.alert('恢复成功', 'success')
              this.handleCloseModal()
              await this.dataSource(this.props.teamno)
          } else {
              app.alert(msg, 'error')
          }
          await this.setData({ restore_loading: false });
        }
      });
    }
  };

  /**
   * 数据
   * @param teamno
   */
  dataSource = (teamno) => {
    this.setData({ data_loading: true }, async () => {
      const params = {
        teamno,
        type: 5,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      };
      let { flag, data, msg } = await app.post(api.LeaveUserList, params);
      if (flag !== 1) {
        app.alert(msg, "error");
      }
      this.setData({
        playerList: utils.addArrayKey(data || []),
        data_loading: false,
      });
    });
  };

  render() {
    const {
        data_loading,
        playerList,
        rights,
        restore_visible,
        restore_loading,
        restoreInfo,
      } = this.state,
      { getFieldDecorator, getFieldValue } = this.props.form,
      formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
      };
      
   if(rights==1){
    var columns = [
      {
        title: "档案编号",
        dataIndex: "indexno",
        key: "indexno",
        width: "20%",
      },
      {
        title: "存心编号",
        dataIndex: "bsrno",
        key: "bsrno",
        width: "15%",
      },
      {
        title: "姓名",
        dataIndex: "vname",
        key: "vname",
        width: "15%",
      },
      {
        title: "性别",
        dataIndex: "sex",
        key: "sex",
        width: "10%",
      },
      {
        title: "入队时间",
        dataIndex: "indate",
        key: "indate",
        width: "15%",
        render(text) {
          return <span>{text || "无记录"}</span>;
        },
      },
      {
        title: "离队时间",
        dataIndex: "outdate",
        key: "outdate",
        width: "15%",
        render(text) {
          return <span>{text || "无记录"}</span>;
        },
      },
      {
        title: "操作",
        dataIndex: "indexno",
        key: "cz",
        width: "15%",
        render: (text, record) => {
          return (
            <div>
              <Button
                onClick={() => this.handleRecovery(record)}
                size="small"
                type="primary"
              >
                原队恢复
              </Button>
            </div>
          );
        },
      }
    ]
   }else{
    var columns = [
      {
        title: "档案编号",
        dataIndex: "indexno",
        key: "indexno",
        width: "20%",
      },
      {
        title: "存心编号",
        dataIndex: "bsrno",
        key: "bsrno",
        width: "15%",
      },
      {
        title: "姓名",
        dataIndex: "vname",
        key: "vname",
        width: "15%",
      },
      {
        title: "性别",
        dataIndex: "sex",
        key: "sex",
        width: "10%",
      },
      {
        title: "入队时间",
        dataIndex: "indate",
        key: "indate",
        width: "15%",
        render(text) {
          return <span>{text || "无记录"}</span>;
        },
      },
      {
        title: "离队时间",
        dataIndex: "outdate",
        key: "outdate",
        width: "15%",
        render(text) {
          return <span>{text || "无记录"}</span>;
        },
      },
    ];
   }
    return (
      <div>
        <Table
          className="ranks_table"
          title={() => <div className="player-table-title">清退队员</div>}
          locale={app.tbLocale(data_loading)}
          columns={columns}
          dataSource={playerList}
          loading={data_loading}
          pagination={false}
          scroll={{ y: "calc(100% - 38px)" }}
          size="small"
        />
        <Modal
          visible={restore_visible}
          title="原队恢复"
          onCancel={this.handleCloseModal}
          onOk={this.handleSubmitRecovery}
          okText="确认"
          cancelText="取消"
          maskClosable={false}
          confirmLoading={restore_loading}
          className="edit-team-modal"
          centered={true}
        >
          <Form>
            <FormItem {...formItemLayout} label="恢复原因">
              {getFieldDecorator("leave_reason", {
                rules: [
                  {
                    required: true,
                    message: "请输入恢复原因！",
                  },
                ],
              })(<Input.TextArea placeholder="请填写恢复原因" rows={4} />)}
            </FormItem>
              <span style={{color:'red'}}>
              注: 恢复后管理员重新设置身份和职位
              </span>
          </Form>
        </Modal>
      </div>
    );
  }
}

ExpulsionList.propTypes = {
  teamno: PropTypes.string.isRequired,
};

export default Form.create()(ExpulsionList);



// WEBPACK FOOTER //
// ./src/routes/ranks/ExpulsionList.jsx